/**
 * Contas do telefone que a tela e o motor dividem (softphone, 25/09/2026).
 * Sem Vue e sem JsSIP: dá para testar sozinho.
 */

// 100–599 e 1000–5999 são ramais; 600+ são serviços (600 = teste de áudio).
export const RAMAL = /^[1-5]\d{2,3}$/;
export const TESTE_DE_AUDIO = '600';

export const ehRamal = numero => RAMAL.test(String(numero || ''));

// Números de serviço da central (não são pessoas): chave de i18n em
// TELEFONE.SERVICO.*. O 600 devolve a própria voz — testa os dois sentidos.
const SERVICOS = { [TESTE_DE_AUDIO]: 'TESTE_AUDIO' };
export const servicoDe = numero => SERVICOS[String(numero || '')] || null;

// O que a pessoa digitou vira o que se disca: só dígitos, *, # e o + inicial.
export const limparNumero = texto => {
  const bruto = String(texto || '').trim();
  const mais = bruto.startsWith('+') ? '+' : '';
  return mais + bruto.replace(/[^\d*#]/g, '');
};

// 7 s → "0:07"; 12 min → "12:05"; 1 h → "1:02:03". Relógio de chamada, não frase.
export const formatarDuracao = ms => {
  const total = Math.max(0, Math.floor((ms || 0) / 1000));
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = String(total % 60).padStart(2, '0');
  return h ? `${h}:${String(m).padStart(2, '0')}:${s}` : `${m}:${s}`;
};

// Como a chamada terminou, pela causa que o JsSIP devolve. Chave de i18n em
// TELEFONE.RESULTADO.*.
export const resultadoDaFalha = (causa, direcao) => {
  const mapa = {
    Busy: 'ocupado',
    Rejected: direcao === 'entra' ? 'recusada' : 'ocupado',
    Canceled: direcao === 'entra' ? 'perdida' : 'cancelada',
    'No Answer': direcao === 'entra' ? 'perdida' : 'sem_resposta',
    'Request Timeout': 'sem_resposta',
    Unavailable: 'indisponivel',
    'Not Found': 'nao_existe',
    'Address Incomplete': 'nao_existe',
    'User Denied Media Access': 'sem_microfone',
    'WebRTC Error': 'sem_audio',
    'Connection Error': 'sem_conexao',
    'Authentication Error': 'sem_conexao',
  };
  return mapa[causa] || (direcao === 'entra' ? 'perdida' : 'falhou');
};

// Resultado que merece a cor de alarme na lista (a ligação que ninguém atendeu).
export const ehPerdida = resultado => resultado === 'perdida';

// As letras do teclado, como no aparelho.
export const TECLAS = [
  { d: '1', l: '' },
  { d: '2', l: 'ABC' },
  { d: '3', l: 'DEF' },
  { d: '4', l: 'GHI' },
  { d: '5', l: 'JKL' },
  { d: '6', l: 'MNO' },
  { d: '7', l: 'PQRS' },
  { d: '8', l: 'TUV' },
  { d: '9', l: 'WXYZ' },
  { d: '*', l: '' },
  { d: '0', l: '+' },
  { d: '#', l: '' },
];
